import React from "react";
import PresvalDropDown from "../PresvalDropDownView";
import {CatalogUserService} from "../../../service/catalog/CatalogUserService";


export default class AccountDropDownContainer extends React.Component {
    constructor(props) {
        super(props);

        this.catalogUserService = new CatalogUserService();

        this.getInstitutionAccounts = this.getInstitutionAccounts.bind(this);
        this.getInstitutionAccountsById = this.getInstitutionAccountsById.bind(this);

        this.state = {
            sessionAccount: props.sessionAccount,
            catInstitutionAccountCatalog: [],
        };

        if (this.state.sessionAccount === undefined || this.state.sessionAccount) {
            this.getInstitutionAccounts();
        }
    }

    getInstitutionAccountsById(institutionId) {
        this.catalogUserService.getCatalogInstitutionAccountsById(institutionId)
            .then(
                dataAccounts => {
                    this.setState({
                        catInstitutionAccountCatalog: dataAccounts,
                    });
                    this.props.loading(false);
                });
    }

    getInstitutionAccounts() {
        this.catalogUserService.getCatalogInstitutionAccounts()
            .then(
                dataAccounts => {
                    this.setState({
                        catInstitutionAccountCatalog: dataAccounts,
                    });
                    this.props.loading(false);
                });
    }

    render() {
        return <PresvalDropDown
            name={this.props.name}
            filter={this.props.filter}
            options={this.state.catInstitutionAccountCatalog}
            save={this.props.save}
            value={this.props.value}
            placeholder={this.props.placeholder}
            tabIndex={this.props.tabIndex}
            disabled={this.props.disabled}
        />
    }
};